import api from "./api";

// WhatsApp messages per client with the WHATSAPP module and per person, this month and last month.
// Meta bills every message Betterfly sends from 01/10/2026 (answers included); received ones are free.
export const getWhatsAppUsage = async () => {
  try {
    const response = await api.get(`/master/whatsapp/usage`);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

// Estimate only: Meta's invoice is the reference (no free allowance is counted).
export const whatsAppCost = (sent, usage) => (sent * usage.unitPriceUsd).toFixed(2);

// D-WA47: what a client's messages of the month cost against its monthly budget (back-office, 20 $ when empty).
export const whatsAppBudget = (tenant, usage) => {
  const spent = (tenant.current || 0) * usage.unitPriceUsd;
  return { spent: spent.toFixed(2), budget: Number.isInteger(Number(tenant.budgetUsd)) ? String(Number(tenant.budgetUsd)) : Number(tenant.budgetUsd).toFixed(2), reached: spent >= tenant.budgetUsd };
};
